import styled from "styled-components";

export const FooterArea = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    gap: 1rem;
`;

export const SignatureSection = styled.section`
    margin-top: 2rem;
    margin-bottom: 2rem;
`;

export const Body = styled.div`
    margin-top: 0;
    margin-bottom: 2rem;
    cursor: default;

    & p:not(:last-child)
    {
        margin-bottom: 1rem;
    }
`;

export const Description = styled.p`
    margin: 0;
    font-size: 18px;
    line-height: 24px;
    color: ${(props: {theme?: { palette?: {lightBlack?: string}}}) => props?.theme?.palette?.lightBlack ?? "#556769"};
`;

export const SuccessMessage = styled.p`
    margin: 0 0 1.5rem;
    font-size: 18px;
    line-height: 24px;
    color: ${(props: { theme?: { palette?: { lightBlack?: string } } }) => props?.theme?.palette?.lightBlack ?? "#556769"};
`;

export const SuccessActions = styled.div`
    margin-top: 2rem;
`;